/**
 * Quote Signing API Service
 */

import { apiClient } from '../client';
import type { ApiResponse, QuoteOrder, SignQuoteRequest } from '../../types';

const API_PREFIX = '/api/saiens/quote';

/**
 * Get quote for viewing (public, token-based)
 */
export async function viewQuote(token: string): Promise<ApiResponse<QuoteOrder>> {
  const response = await apiClient.get<ApiResponse<QuoteOrder>>(`${API_PREFIX}/view/${token}`);
  return response.data;
}

/**
 * Sign quote (public, token-based)
 */
export async function signQuote(
  token: string,
  data: SignQuoteRequest
): Promise<ApiResponse<{ order_id: number; order_name: string; signed_date: string }>> {
  const response = await apiClient.post<
    ApiResponse<{ order_id: number; order_name: string; signed_date: string }>
  >(`${API_PREFIX}/sign/${token}`, data);
  return response.data;
}

/**
 * Get signature image URL
 */
export function getSignatureUrl(orderId: number, token?: string): string {
  const baseUrl = apiClient.defaults.baseURL || '';
  let url = `${baseUrl}${API_PREFIX}/signature/${orderId}`;
  if (token) {
    url += `?token=${token}`;
  }
  return url;
}

/**
 * Get quote PDF URL
 */
export function getQuotePdfUrl(token: string): string {
  const baseUrl = apiClient.defaults.baseURL || '';
  return `${baseUrl}${API_PREFIX}/pdf/${token}`;
}

/**
 * Confirm quote (without signature)
 */
export async function confirmQuote(
  token: string,
  confirmedByName?: string
): Promise<ApiResponse<{ order_id: number; order_name: string; state: string }>> {
  const response = await apiClient.post<
    ApiResponse<{ order_id: number; order_name: string; state: string }>
  >(`${API_PREFIX}/confirm/${token}`, {
    confirmed_by_name: confirmedByName,
  });
  return response.data;
}
